<div class="more-option dropdown">
  <button type="button" id="platformSwitchButton" class="btn btn-clear dropdown-toggle" data-toggle="dropdown"
    data-display="static" aria-haspopup="true" aria-expanded="false" data-reference="parent"
    attr.aria-controls="dropdownItems_{{rowIndex}}">
    <em class="material-icons-outlined font-4x pt-1">
      <span aria-hidden="true">more_horiz</span>
      <span class="sr-only sr-only-focusable">switch platform</span>
    </em>
  </button>

  <div class="dropdown-menu px-0 py-2" aria-labelledby="platformSwitchButton">
    <ul class="mb-0 list-unstyled" id="dropdownItems_{{rowIndex}}" role="menu">
      <li role="none" *ngFor="let item of platformList">
        <button *ngIf="item.flag" class="dropdown-item btn font-2x" id="{{item.propName}}Btn"
          [ngClass]="{'active':item.propName === 'standards'}" (click)="openExternalLink(item.propName);"
          [disabled]="item.propName === 'standards'">
          {{item.displayName}}
        </button>
      </li>
    </ul>
  </div>
</div>
